export default "__VITE_ASSET__DEhChInD__"